import styled from "styled-components";
import colors from "@streeteasy/design-system/deprecated/colors";

export const DealTable = styled.table`
  width: 100%;

  tr {
    border-bottom: 1px solid ${colors.rabbitGrey};
    line-height: 40px;
  }

  td {
    line-height: 22px;
    padding: 16px 0;

    &:first-child {
      min-width: 50px;
      padding-right: 10px;
    }
  }
`;

export const LoadingOverlay = styled.div`
  position: relative;

  &::after {
    background: grey;
    content: "Loading...";
    height: 100%;
    left: 0;
    opacity: 35%;
    position: absolute;
    text-align: center;
    top: 0;
    user-select: none;
    vertical-align: middle;
    width: 100%;
  }
`;
